<p-toast position="top-right" key="msj"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" key="kc" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
  rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar" [rejectVisible]="false">
</p-confirmDialog>
<div class="container-fluid" style="border-color: blue; border: 5px ; width: 90%;">
  <div class="row">
    <div class="col-md-12">
      <div class="card card-shadow sinborde">
        <div class="card-header sinborde" style="background: none; ">
          <!-- <div class="grid">
            <div class="col-12 xl:col" style="display: inline-flex; align-items: end;">
              <div class="col-3 cardicono rounded">
                <i class="pi pi-history mt-3" style="font-size: 2rem; color: #fff;"></i>
              </div>
              <header style="left: 11%; top: 5%;">Consulta de operacion
                <div style="color:#3b9be9; display: inline;">Operación Diaria</div>
              </header>
            </div>
          </div> -->
          <div class="grid">

            <div class="col-2 cardicono rounded"
              style="display: flex; justify-content: center; align-items: center; height: 60px;">
              <i class="pi pi-history " style="font-size: 2rem; color: #fff;"></i>
            </div>
            <div class="col-12 xl:col">
              <header>Consulta de
                <div>Operación Diaria</div>
              </header>
            </div>
          </div>
          <div class="row mt-5 ml-5 d-flex justify-content-center align-items-center">
            <div class="grid d-flex flex-wrap">

              <!-- Columna para el ícono y la etiqueta -->
              <div class="col-12 sm:col-6 md:col-2 lg:col-2 xl:col-2" style="display: inline-flex; align-items: end;">
                <i class="pi pi-calendar color-icon mr-3 mt-1" style="font-size: 2rem; color: #3b9be9;"></i>
                <label for="lblligero" class="col-sm color-font text-left"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif; left: 11%; top: 5%; padding-right: 1;">
                  Fecha</label>
              </div>

              <!-- Columna para el input de fecha -->
              <div class="col-12 sm:col-6 md:col-3 lg:col-3 xl:col-3" style="align-content: flex-end; min-width: 10vw; max-width: 30vw;">
                <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha"
                  [style]="{ minWidth: '100%', width: '100%' }" tooltipPosition="top" [(ngModel)]="fecha_dia">
                <hr class="my-0">
              </div>

              <!-- Columna para el botón de filtrar -->
              <div class="col-12 sm:col-6 md:col-3 lg:col-3 xl:col-3" style="align-content: flex-end;">
                <button pButton pRipple type="button" (click)="cargarInformacionPorFecha(fecha_dia,fecha_fin);"
                  label="Filtrar" icon="pi pi-filter" iconPos="left" class="custom-buttoncargar "></button>
              </div>

              <!-- Columna para el botón de reiniciar filtro -->
              <div class="col-12 sm:col-6 md:col-3 lg:col-3 xl:col-3" style="align-content: flex-end;">
                <button *ngIf="mostrarbtnLimpiarFiltro" pButton pRipple type="button" (click)="LimpiarFiltro();"
                  label="Reiniciar" icon="pi pi-filter-slash" iconPos="left" class="custom-warn"></button>
              </div>

            </div>
          </div>


        </div>
      </div>
    </div>
    <div>
      <p-table #dt1 [value]="lstMovimientos" [scrollable]="true" scrollHeight="flex" scrollDirection="both"
        [paginator]="true" [rows]="150" [rowsPerPageOptions]="[150,200,300,500]" [showCurrentPageReport]="true"
        currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
        [globalFilterFields]="['num_economico','nombre_chofer','num_folio','desc_tipo_aprovechamiento']"
        [loading]="loading">
        <ng-template pTemplate="caption">

          <div class="row d-flex justify-content-center ">
            <div class="col-12 sm:col-6 xl:col-3">
              <p-columnFilter type="text" field="desc_ruta" placeholder="Ruta" class="form-control sinborde filtro"
                matchMode="contains"></p-columnFilter>
            </div>
            <div class="col-12 sm:col-6  xl:col-3">
              <p-columnFilter type="text" field="desc_cliente" placeholder="Cliente"
                class="form-control sinborde filtro" matchMode="contains"></p-columnFilter>
            </div>

            <div class="col-12 sm:col-6 xl:col-3 mt-1">
              <p-columnFilter field="id_ciudad" matchMode="equals" [showMenu]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown [ngModel]="value" [options]="lstCiudades" optionLabel="nombre" optionValue="id"
                    (onChange)="filter($event.value)" placeholder="Filtrar ciudad" [showClear]="true">
                  </p-dropdown>
                </ng-template>
              </p-columnFilter>
            </div>
            <div class="col-12 sm:col-6 xl:col-3">
              <span class="p-input-icon-left">
                <i class="pi pi-search" style="margin-right: 5px;"></i>
                <input pInputText pTooltip="Buscar por: Nombre del colaborador, Ciudad o Evento" type="text"
                  (input)="applyFilterGlobal($event, 'contains')" placeholder="Buscar" style="margin-left: 5px;" />
              </span>
            </div>

          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center">#</th>
            <th pSortableColumn="desc_ruta">Ruta<p-sortIcon field="desc_ruta"></p-sortIcon></th>
            <th pSortableColumn="desc_tiporuta">Tipo de Ruta<p-sortIcon field="desc_tiporuta"></p-sortIcon></th>
            <th class="text-center">Ciudad</th>
            <th class="text-center">#Economico</th>
            <!-- <th class="text-center">Generales</th> -->
            <th class="text-center">Colaborador</th>
            <th class="text-center">Fecha</th>
            <th class="text-center" style="min-width: 150px; max-width: 150px;" pSortableColumn="clv_fin_ruta">
              <p-sortIcon field="clv_fin_ruta"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
          <tr>
            <td class="text-center">{{ (rowIndex+1) }}</td>
            <td [ngClass]="{'col-header-sp': data.clv_especial==1}">{{data.desc_ruta}}
              <p style="display: inline-block; color: rgb(20, 170, 20) !important;font-weight: bold;">
                {{ data.desc_folio}}</p>
              <p *ngIf="data.clv_especial==2"
                style="display: inline-block; color: orange !important;font-weight: bold;">
                SIN COBRO</p>
              <p *ngIf="data.clv_especial==3"
                style="display: inline-block; color: orange !important;font-weight: bold;">
                SIN NOMINA</p>
                <small style="display: inline-block; color: #8d58f0" *ngIf="data.rostering_id != ''"><b>
                  (Rostering ID: {{ data.rostering_id}})</b></small>
            </td>
            <td [ngClass]="{'col-header-sp': data.clv_especial==1}">{{data.desc_tiporuta}}
              <p *ngIf="data.clv_cancelado==1" class="col-orange col-md-6 mt-2"
                pTooltip="La ruta se marco como Cancelada por Operaciones">CANCELADA</p>
              <p style="display: inline-block; color: #3b9be9 !important;font-weight: bold;">
                {{data.desc_tipo_aprovechamiento}}</p>
            </td>
            <td class="text-center">{{data.desc_ciudad}}</td>
            <td class="text-center" style="  color: rgb(20, 170, 20); font-weight: bold;">{{data.num_economico}}</td>
            <!-- <td>{{data.datos_generales}}</td> -->
            <td style=" color: #783be9; font-weight: bold; font-size: 12px;">
              <ol>
                <li>{{'(Principal) '+data.nombre_chofer}}</li>
                <li *ngIf="data.id_puesto1!=0">{{'('+data.desc_puesto_adicional1+') '+data.nombre_completo_adicional1}}
                </li>
                <li *ngIf="data.id_puesto2!=0">{{'('+data.desc_puesto_adicional2+') '+data.nombre_completo_adicional2}}
                </li>
              </ol>
            </td>
            <td class="text-center">
              <div>{{data.fecha_registro | date: 'dd/MM/yyyy'}}</div>
              <div class="col-hora text-center">{{data.hora}}</div>
            </td>
            <td style="min-width: 150px; max-width: 150px;" class="text-center">
              <div>
                <div class="d-flex justify-content-center" *ngIf="data.clave_ruta != 0" >
                  <p-button label="Gestión" icon="pi pi-eraser"
                      styleClass="p-button-raised p-button-secondary"
                      pTooltip="Recursos" tooltipPosition="top"
                      (onClick)="mostrarRecursos(data)"></p-button>
                </div>
                <div class="d-flex justify-content-around mt-2">
                  <p-tag *ngIf="data.fecha<=fecha_dia_real && data.clv_fin_ruta==0" severity="warning"
                    value="EN TRANSITO"></p-tag>
                </div>
                <div class="d-flex justify-content-around mt-2">
                  <p-tag *ngIf="data.clv_fin_ruta==1" severity="success" value="FINALIZADA"></p-tag>
                  <p-tag *ngIf="data.clv_fin_ruta==0" severity="danger" value="NO FINALIZADA"></p-tag>
                </div>
              </div>
            </td>

          </tr>
        </ng-template>
      </p-table>
    </div>


  </div>
 <!--ADMINISTRADOR DE RECURSOS-->
<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspRecursos" [style]="{'width': '60vw','height':'70vh'}"
  [transitionOptions]="'0ms'" styleClass="card-shadow" (onHide)="cancelarModal()">
  <ng-template pTemplate="header">
    <div class="d-flex justify-content-start">
      <div class="col-md-12">Consulta Combustible Ruta {{texto_fecha_recurso | date: 'dd/MM/yyyy'}}
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="mt-3">
      <div class="row">
        <div class="col-md-12 texto-lila d-flex justify-content-between">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <p class="d-flex align-items-center texto-naranja">Numero Economico: {{recurso.num_economico}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-7">APARTADO COMBUSTIBLE -->
          <div class="row">
            <div class="col-sm-5 d-flex justify-content-between">
              <p class="m-0 texto-valido">Estatus Combustible:</p>
              <p class="col-orange">{{messageFinCombustible}}</p>
            </div>
          </div>
        <!-- </div> -->
        <hr class="mt-5">
        <div class="row">
          <!-- <p-table [value]="listCombustible" [tableStyle]="{ 'min-width': '30rem','height':'200px' }" -->
          <p-table [value]="listCombustible"
            [tableStyle]="{ 'min-width': '40rem','width':'100%','height':'70%','margin-left': 'auto', 'margin-right':'auto'}"
            styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex" scrollHeight="70%"
            [loading]="loading_combustible">
            <ng-template pTemplate="header">
              <tr>
                <th>#</th>
                <th>Litros</th>
                <!-- <th>Precio</th>
                <th>Total</th> -->
                <th>Pago</th>
                <!-- <th>Km.Inicial</th> -->
                <th>Km.Final</th>
                <!-- <th>Recorridos</th> -->
                <!-- <th>Rendimiento</th> -->
                <!-- <th>Info</th> -->
                <!-- <th></th> -->
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
              <tr *ngIf="data.clv_guardado==1">
                <td class="col-hora">{{ (rowIndex+1) }}</td>
                <td>{{ data.num_litros_combustible }}</td>
                <!-- <td>{{ data.imp_litro | currency }}</td>
                <td>{{ data.imp_total_combustible | currency }}</td> -->
                <td class="texto-lila">{{ data.desc_pago+'('+data.nom_combustible+')' }}
                  <p class="d-inline" style="font-size: 9px;">{{ data.fec_registro | date: 'dd/MM/yyyy' }}</p>
                </td>
                <!-- <td>{{ data.kim_inicial_carga | thousand}}</td> -->
                <td>{{ data.kim_final_carga | thousand}}</td>
                <!-- <td>{{ data.kim_recorridos | thousand }}</td> -->
                <!-- <td class="texto-black">{{ data.num_rendimiento | number:'1.2' }}</td> -->
                <!-- <td style="font-size: 9px; color: brown;">
                  <p pTooltip="Registro" tooltipPosition="left">{{ data.nom_usuario }}</p>
                </td> -->
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <hr class="mt-5">
      <!-- <div class="row mt-2">
        <div class="form-group col-md-6">
          <div class="row g-0">
            <div class="col-sm-4 mx-0">
              <span class="input-group-addon"> <i class="pi pi-map-marker color-icon"
                  style="font-size: 1.5rem"></i>Kim.Inicial
              </span>
            </div>
            <div class="col-sm-8">
              <input type="number" class="form-control" placeholder="Kilometraje Inicial" value="{{this.kim_inicial_carga}}"
                style="text-transform:uppercase;" min="0" pTooltip="Kilometraje Inicial" tooltipPosition="left"
                [disabled]="true" autocomplete="off">
              <hr class="my-0">
            </div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <div class="row g-0">
            <div class="col-sm-4 mx-0">
              <span class="input-group-addon"> <i class="pi pi-map-marker color-icon"
                  style="font-size: 1.5rem"></i>Kim.Final
              </span>
            </div>
            <div class="col-sm-8">
              <input type="number" class="form-control" placeholder="Kilometraje Final" value="{{this.kim_final_carga}}"
                style="text-transform:uppercase;" min="0" pTooltip="Kilometraje Final" tooltipPosition="top"
                [disabled]="true" autocomplete="off">
              <hr class="my-0">
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-start">
        <div class="col-6">
          <p class="texto-black">*Rendimiento=(Kilómetros Recorridos)/Cantidad de litros de la carga.</p>
        </div>
      </div> -->
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="cancelarModal();"></button>
  </ng-template>
</p-dialog>
